import React, {Component} from 'react';
import cx from 'classnames';
import invoke from 'lodash.invoke';
import prop from 'ramda/src/prop.js';
import {withPickList} from '../context';

const labelClasses = 'text-inherit mb-2 border-solid box-border-round t-bg-color t-duration-short bg-white hover:bg-near-white';

class PickListItem extends Component {

    handleInput = e => {
        const {pickList} = this.props;
        let doHandleInput = false;

        switch ( e.type ) {
            case 'click':
                // Bug: onClick firing when radio button is selected with arrow keys
                // resource -> https://github.com/facebook/react/issues/7407
                if ( e.clientX !== 0 && e.clientY !== 0 ) {
                    doHandleInput = true;
                }
                break;

            case 'keydown':
                // [SPACE key]
                if ( e.which === 32 ) {
                    doHandleInput = true;
                }
                break;
        }

        if ( doHandleInput ) {
            invoke( pickList.actions, 'handleItemChange', e.target.value );
        }
    };

    render () {
        const {itemIdProp, selectedItem, groupId} = this.props.pickList;
        const itemId = prop( itemIdProp, this.props ) || '';
        const isChecked = prop( itemIdProp, selectedItem ) === itemId;
        const ListItem = this.props.renderer || DefaultRenderer;

        // note - remove unwanted prop "Symbol" from prop list to avoid issue with overriding native Symbol
        delete this.props.Symbol;

        return (
            <label htmlFor={`${groupId}-${itemId}`} className={labelClasses}>
                <ListItem {...this.props}>
                <span className="wrap-check mr-4">
                    <input id={`${groupId}-${itemId}`}
                           type="radio"
                           tabIndex="0"
                           name={groupId}
                           defaultValue={itemId}
                           checked={isChecked}
                           onChange={this.handleInput}
                           onKeyDown={this.handleInput}
                           onClick={this.handleInput}/>
                    <span className={cx( 'radio', {checked: isChecked} )}></span>
                </span>
                </ListItem>
            </label>
        );
    }
}

const DefaultRenderer = ( {className = '', children, ...data} ) => (
    <div className={className}>
        {children}
        {Object
            .entries( data )
            .map( ( [key, value] ) =>
                <span key={key} className="block">{key} - {String( value )}</span>
            )}
    </div>
);

export default withPickList( PickListItem );
